import React from "react"
import Divide from "./Section/Divide"
import { StaticImage } from "gatsby-plugin-image"
export default function HighLight() {
  const list = [
    {
      title: "VIP",
      description: "Access to Ibiza's hottest spots",
      svg: (
        <svg
          width="23"
          height="21"
          stroke="none"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 576 512"
        >
          <path
            fill="#A5A58F"
            d="M576 136c0 22.09-17.91 40-40 40c-.248 0-.4551-.1266-.7031-.1305l-50.52 277.9C482 468.9 468.8 480 453.3 480H122.7c-15.46 0-28.72-11.06-31.48-26.27L40.71 175.9C40.46 175.9 40.25 176 39.1 176c-22.09 0-40-17.91-40-40S17.91 96 39.1 96s40 17.91 40 40c0 8.998-3.521 16.89-8.537 23.57l89.63 71.7c15.91 12.73 39.5 7.544 48.61-10.68l57.6-115.2C255.1 98.34 247.1 86.34 247.1 72C247.1 49.91 265.9 32 288 32s39.1 17.91 39.1 40c0 14.34-7.963 26.34-19.3 33.4l57.6 115.2c9.111 18.22 32.71 23.4 48.61 10.68l89.63-71.7C499.5 152.9 496 144.1 496 136C496 113.9 513.9 96 536 96S576 113.9 576 136z"
          />
        </svg>
      ),
    },
    {
      title: "Faster Access",
      description:
        "Skip going around and get straight to the stuff everyone wants to experience.",
      svg: (
        <svg
          width="23"
          height="21"
          viewBox="0 0 23 21"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M20.2913 2.61183C19.7805 2.10083 19.1741 1.69547 18.5066 1.41891C17.8392 1.14235 17.1238 1 16.4013 1C15.6788 1 14.9634 1.14235 14.2959 1.41891C13.6285 1.69547 13.022 2.10083 12.5113 2.61183L11.4513 3.67183L10.3913 2.61183C9.3596 1.58013 7.96032 1.00053 6.50129 1.00053C5.04226 1.00053 3.64298 1.58013 2.61129 2.61183C1.5796 3.64352 1 5.04279 1 6.50183C1 7.96086 1.5796 9.36013 2.61129 10.3918L11.4513 19.2318L20.2913 10.3918C20.8023 9.88107 21.2076 9.27464 21.4842 8.60718C21.7608 7.93972 21.9031 7.22431 21.9031 6.50183C21.9031 5.77934 21.7608 5.06393 21.4842 4.39647C21.2076 3.72901 20.8023 3.12258 20.2913 2.61183Z"
            stroke="#A5A58F"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      ),
    },
    {
      title: "Friendly Help",
      description: "Get ongoing support to make your vacation stress-free.",
      svg: (
        <svg
          width="20"
          height="21"
          viewBox="0 0 20 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M9.08861 2.39919V9.90142C9.08861 10.3984 9.49564 10.8012 9.9977 10.8012C10.4998 10.8012 10.9068 10.3984 10.9068 9.90142V3.87084C10.9068 3.58355 11.1543 3.29996 11.5102 3.29791C11.8284 3.29598 12.1212 3.59132 12.1212 3.90269V12.9008C12.1212 13.2699 12.349 13.6017 12.6958 13.7375C13.0416 13.8729 13.4359 13.7862 13.6912 13.5188L13.692 13.5178L13.6952 13.5146C13.7001 13.5095 13.7092 13.5004 13.7222 13.4877C13.7481 13.4623 13.7898 13.4227 13.8456 13.3728C13.9577 13.2727 14.1238 13.1341 14.3322 12.988C14.7585 12.6893 15.313 12.3935 15.9113 12.2898C16.5625 12.1769 17.1802 12.2457 17.5908 12.4557C17.8436 12.5849 18.0416 12.7736 18.1305 13.0895L16.1204 14.5854C16.0864 14.6107 16.0543 14.6383 16.0241 14.668L13.3875 17.2751C12.2547 18.3951 11.3122 19.6891 10.5964 21.1067C10.2579 21.777 9.56582 22.2004 8.80873 22.2004H5.50234C4.80926 22.2004 4.2068 21.8731 3.89527 21.345C3.00343 19.8329 1.81818 17.4003 1.81818 15.3046V6.00225C1.81818 5.68021 2.07885 5.4023 2.42564 5.4023C2.77589 5.4023 3.03526 5.6791 3.03526 6.00225V10.2014C3.03526 10.6983 3.44228 11.1012 3.94435 11.1012C4.44642 11.1012 4.85344 10.6983 4.85344 10.2014V3.90269C4.85344 3.56885 5.11335 3.29792 5.45455 3.29792C5.80227 3.29792 6.06061 3.56856 6.06061 3.90269V9.90142C6.06061 10.3984 6.46762 10.8012 6.9697 10.8012C7.47176 10.8012 7.87879 10.3984 7.87879 9.90142V2.39919C7.87879 2.07206 8.13588 1.79988 8.48315 1.79962C8.83515 1.79936 9.08861 2.06716 9.08861 2.39919ZM11.4989 1.49833C11.2428 1.49983 10.9993 1.53911 10.7724 1.60995L11.4989 1.49833ZM10.7724 1.60995C10.4542 0.699885 9.59709 -0.000851044 8.4817 7.75776e-07C7.37176 0.000852596 6.51561 0.703016 6.19633 1.6093C5.9659 1.5375 5.71743 1.4983 5.45455 1.4983C4.11091 1.4983 3.15592 2.52487 3.04588 3.67962C2.85002 3.62957 2.64255 3.60268 2.42564 3.60268C1.00827 3.60268 0 4.75337 0 6.00225V15.3046C0 17.9208 1.41987 20.7176 2.32509 22.2523C2.99955 23.3958 4.23977 24 5.50234 24H8.80873C10.2547 24 11.5764 23.1914 12.2228 21.9112C12.851 20.667 13.6783 19.5313 14.6725 18.5482L17.264 15.9858L19.6372 14.2199C19.8656 14.0499 20 13.7836 20 13.5007C20 12.2269 19.356 11.3326 18.4252 10.8568C17.5577 10.4132 16.5073 10.3594 15.5973 10.5171C14.9686 10.6263 14.4059 10.8573 13.9394 11.1109V3.90269C13.9394 2.6305 12.8628 1.49021 11.4989 1.49833"
            fill="#A5A58F"
          />
        </svg>
      ),
    },
  ]

  return (
    <Divide
      className="static -mt-64"
      image={
        <StaticImage
          src="../../images/index3/highlight.jpeg"
          alt="second"
          className="h-[36rem] md:h-full w-full object-cover"
        />
      }
    >
      <div className="pt-24 md:pt-44">
        <h2 className="font-serif3 text-center md:text-left text-3xl sm:text-4xl lg:text-5xl lg:leading-[56px] font-bold text-[#7E7E66]">
          Relax, we’ve got Ibiza covered!
        </h2>
        <p className="text-[16px] text-center md:text-left lg:max-w-[28rem] py-8">
          From your ride from Ibiza airport, your stay in one of the best luxury
          vacation homes Ibiza has to offer, to unforgettable experiences we’ve
          curated for you, we take your Ibiza stay to the next level.
        </p>
        <div className="w-3/4 md:w-full mx-auto grid gap-4 sm:gap-0 sm:flex sm:space-x-3 sm:items-center pb-10 md:pb-20">
          <button className="bg-[#EC4B28] font-bold text-white uppercase text-xs px-10 py-4 rounded-full">
            Design MY Ibiza Stay
          </button>
          <button className="bg-[#FDF1E7] font-bold text-[#C39B82] uppercase text-xs px-10 py-4 rounded-full">
            Browse Our Stays
          </button>
        </div>
        <div className="py-2 md:py-12 lg:relative lg:-left-4 gap-8 sm:gap-0 sm:space-x-2 grid sm:flex">
          {list.map((s, key) => {
            return (
              <div key={key} className="flex flex-col gap-4">
                <div className="flex justify-center">{s.svg}</div>
                <h3 className="text-center text-sm font-bold">{s.title}</h3>
                <p className="text-xs text-center">{s.description}</p>
              </div>
            )
          })}
        </div>
      </div>
    </Divide>
  )
}
